<div class="m-0 text-lg text-[#53565b] flex items-start flex-col">   
    <p>Do you want to add or link <span class="font-bold text-k-blue">{{data.header }}</span> to <span class="font-bold text-k-blue"> {{ username}}'s {{data.form_name }}</span></p>
</div>

<div class="flex flex-col gap-3 w-[291px]">
<div
 class="app__discovery-option-form"
 (click)="continue('yes')"

>
<span class="text-[20px] m-0 font-open-sans text-[#53565B] font-semibold leading-[22.5px]">
  Yes
</span>
</div>

<div
 class="app__discovery-option-form"
 (click)="continue('complete_later')"
>
<span class="text-[20px] m-0 font-open-sans text-[#53565B] font-semibold leading-[22.5px]">
    No
</span>
</div>
<div
 class="app__discovery-option-form"
 (click)="continue('no')"
>
<span class="text-[20px] m-0 font-open-sans text-[#53565B] font-semibold leading-[22.5px]">
 No
</span>
</div>
</div>

<mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>
<div class="flex items-start justify-between pl-0 pr-0 w-full h-[65px] mt-4">
  <!-- <button  class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" (click)="back()">
    <span class="flex items-center gap-2 text-[#18191C]"
      ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
    >
  </button> -->
<div
class="w-[158px]"
 >
  </div>
</div>